import { render, staticRenderFns } from "./FaqHeader.vue?vue&type=template&id=c7dde4d8&scoped=true"
var script = {}
import style0 from "./FaqHeader.vue?vue&type=style&index=0&id=c7dde4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dde4d8",
  null
  
)

export default component.exports